import { useMutation, useQueryClient } from '@tanstack/react-query';
import { collegesService } from '@/services/colleges.service';
import type { CollegeCreate } from '@/types/api';
import { toast } from 'sonner';

export function useCreateCollege() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      college,
      mascot,
    }: {
      college: CollegeCreate;
      mascot?: File;
    }) => {
      let mascotId: string | null = college.mascotId ?? null;

      if (mascot) {
        const uploaded = await collegesService.uploadMascot(mascot);
        mascotId = uploaded.id;
      }

      return collegesService.createCollege({
        ...college,
        mascotId,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['schools'] });
      toast.success('College created successfully');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to create college');
    },
  });
}
